import React from 'react';
import PropTypes from 'prop-types';
import { OutOfStockText, ProductNotFoundText, ProductNotFoundBackButtonWrapper } from './styled';
import { Anchor } from '../../components_desktop/css_global/utils.css';
import VerticalSpacer from '../VerticalSpacer/VerticalSpacer';
import ProductMicrodata from '../Microdata/ProductMicrodata';
import withCountryCode from '../../components/RoutesHoc/RoutesHoc';

const renderDesktopCopy = () => {
  return (
    <>
      <OutOfStockText fontSize="15px" lineHeight="18px">
        Sorry, this product is out of stock. Click here to find more
      </OutOfStockText>
      <VerticalSpacer height="30px" />
    </>
  );
};

const renderMobileCopy = () => {
  return (
    <>
      <OutOfStockText>Sorry, this product is out of stock.</OutOfStockText>
      <VerticalSpacer height="5px" />
      <div>Tap to find more from</div>
      <VerticalSpacer height="50px" />
    </>
  );
};

const ProductNotFoundCard = ({
  buttonText,
  buttonUrl,
  isDesktop,
  model,
  image,
  buildUrlWithCountry,
  countryCode,
  freeShipping,
  price,
  currencyIso,
}) => {
  const finalButtonText = buttonText || 'Home';
  const finalButtonUrl = buttonUrl || buildUrlWithCountry();

  return (
    <>
      <div className="product_not_found" data-cy="product-not-found">
        <ProductNotFoundText>{isDesktop ? renderDesktopCopy() : renderMobileCopy()}</ProductNotFoundText>
        <ProductNotFoundBackButtonWrapper>
          <Anchor
            href={finalButtonUrl}
            backgroundColor="#000000"
            borderRadius="0px"
            border="none"
            data-cy="button-to-category"
            fontSize="15px"
            height="40px"
          >
            {finalButtonText}
          </Anchor>
        </ProductNotFoundBackButtonWrapper>
      </div>
      <ProductMicrodata
        countryCode={countryCode}
        currencyIso={currencyIso}
        freeShipping={freeShipping}
        image={image}
        isOutOfStock
        price={price}
        productName={model}
      />
    </>
  );
};

ProductNotFoundCard.defaultProps = {
  isDesktop: false,
};

ProductNotFoundCard.propTypes = {
  buttonText: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool,
  model: PropTypes.string,
  buildUrlWithCountry: PropTypes.func.isRequired,
  image: PropTypes.string,
};

export default withCountryCode(ProductNotFoundCard);
